import { PlatformCode } from 'type/common';
import {
	IDashboardGroupDB,
	IDashboardGroupSummaryDB,
	IGroupsPerformances,
} from 'type/dashboard';
import { ICreatorRankDB, IDailyPerformanceDB, IGroupsInsightsDB } from 'type/db';

import { api } from './api';

export const wconcept_dashboard_apis = {
	getDashboardGroups: async () => {
		const data = await api.get('api/groups');
		return data.data as IDashboardGroupDB[];
	},
	getDashboardGroupSummary: async (groupId: string) => {
		const data = await api.get(`api/groups/${groupId}/summary`);
		return data.data as IDashboardGroupSummaryDB;
	},
	//GET /api/groups/{groupId}/rankings?order_by=''
	getCreatorRankings: async (groupId?: string, orderBy?: string) => {
		const data = await api.get(`api/groups/${groupId}/rankings?order_by=${orderBy}`);
		return data.data as ICreatorRankDB[];
	},

	getMissionPerformance: async (groupId?: string, missionNumber?: string) => {
		const data = await api.get(
			`api/groups/${groupId}/missions/${missionNumber}/performances/daily`,
		);

		return data.data as IDailyPerformanceDB;
	},
	// GET /groups/{groupId}/performances
	getGroupPerformances: async (groupId?: string) => {
		const data = await api.get(`api/groups/${groupId}/performances`);
		return data.data as IGroupsPerformances;
	},
	// GET /groups/{groupId}/rankings?order_by=''
	getGroupRankings: async (groupId: number, order_by?: string) => {
		if (order_by === undefined) {
			const data = await api.get(`api/groups/${groupId}/rankings`);
			return data.data as ICreatorRankDB[];
		}

		const data = await api.get(`api/groups/${groupId}/rankings?order_by=${order_by}`);
		return data.data as ICreatorRankDB[];
	},
	//GET /groups/{groupId}/missions/{missionNumber}/rankings?order_by=''
	getMissionRankings: async (
		groupId: string,
		missionNumber: string,
		order_by?: string,
	) => {
		if (order_by === undefined) {
			const data = await api.get(
				`api/groups/${groupId}/missions/${missionNumber}/rankings`,
			);
			return data.data as ICreatorRankDB[];
		}

		const data = await api.get(
			`api/groups/${groupId}/missions/${missionNumber}/rankings?order_by=${order_by}`,
		);
		return data.data as ICreatorRankDB[];
	},
	//GET /groups/{groupId}/insights
	getGroupInsights: async (groupId: string) => {
		const data = await api.get(`api/groups/${groupId}/insights`);
		return data.data as IGroupsInsightsDB;
	},
	//GET /groups/{groupId}/creators?progress=""
	getChannelList: async (groupId: number, progress: string) => {
		const data = await api.get(
			`api/groups/${groupId}/creators?progress=${encodeURIComponent(progress)}`,
		);
		return data.data;
	},

	//GET /api/groups/{groupId}/creators?progress=""
	getCreaterReports: async (groupId: number, progress: string) => {
		const data = await api.get(
			//`api/groups/${groupId}/creators?progress=${encodeURIComponent(progress)}`,
			`api/groups/${groupId}/creators`,
		);
		return data.data;
	},
};
